import { z } from "zod";

import {
  TEXT_EXTRA_SMALL_LENGTH,
  TEXT_SHORT_LENGTH,
  TEXT_SMALL_LENGTH,
  usaStates,
} from "~/common/constants";
import { PRONOUNS } from "~/patients/constants/constants";
import { pronounsSchema } from "~/patients/utils/PatientSchemas";

export const updatePatientPhoneNumberSchema = z.object({
  mobileNumber: z
    .string()
    .min(1, "Phone number is required")
    .regex(/^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/, {
      error: "Must be a valid phone number",
    }),
  email: z
    .email()
    .max(TEXT_SMALL_LENGTH, "Email must be less than 70 characters"),
});

export const updatePatientDetailsFormSchema = z
  .object({
    patientId: z.string(),
    name: z.string(),
    lastName: z.string(),
    pronouns: pronounsSchema,
    dateOfBirth: z
      .string({ error: "Date of birth is required" })
      .min(1, "Date of birth is required"),
    streetAddress: z
      .string()
      .min(1, "Street address is required")
      .max(TEXT_SMALL_LENGTH, "Street address must be less than 70 characters")
      .optional(),
    apartment: z
      .string()
      .max(TEXT_SMALL_LENGTH, "Apartment must be less than 70 characters")
      .optional(),
    city: z
      .string()
      .min(1, "City is required")
      .max(TEXT_EXTRA_SMALL_LENGTH, "City must be less than 30 characters")
      .optional(),
    state: z.enum(usaStates).optional(),
    zipCode: z
      .string()
      .min(5, { error: "Zipcode must contain at least 5 numbers" })
      .optional(),
    emergencyContactFirstName: z
      .string()
      .min(1, "First name is required")
      .max(
        TEXT_EXTRA_SMALL_LENGTH,
        "First name must be less than 30 characters",
      ),
    emergencyContactLastName: z
      .string()
      .min(1, "Last name is required")
      .max(
        TEXT_EXTRA_SMALL_LENGTH,
        "Last name must be less than 30 characters",
      ),
    emergencyContactRelationship: z
      .string()
      .min(1, "Relatioship is required")
      .max(TEXT_SHORT_LENGTH, "Relationship must be less than 200 characters"),
    emergencyCustomRelationship: z
      .string()
      .max(
        TEXT_SHORT_LENGTH,
        "Custom relationship must be less than 200 characters",
      )
      .optional(),
    emergencyContactMobileNumber: z
      .string()
      .min(1, "Phone number is required")
      .regex(/^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/, {
        error: "Must be a valid phone number",
      }),
    emergencyContactEmail: z
      .email({ error: "Email must be valid" })
      .min(1, "Email is required")
      .max(TEXT_SMALL_LENGTH, "Email must be less than 70 characters"),
  })
  .refine(
    (data) => {
      if (data.emergencyContactRelationship !== PRONOUNS.other) return true;
      if (!data.emergencyCustomRelationship) return false;
      if (data.emergencyCustomRelationship.trim().length === 0) return false;

      return true;
    },
    {
      path: ["emergencyCustomRelationship"],
      error: "Custom relationship is required when 'Other' is selected",
    },
  );
